import { gql } from "@/__generated__/gql";

export const ORG_TIMEZONE = gql(`
query orgTimeZone($id: ID!) {
    node(id: $id) {
      id
      ... on Organization {
        id
        timeZone
      }
    }
  }
`);
